import React, { useRef, useEffect } from 'react';
import { Heading, Copy } from 'components/components/atoms';
import styled from 'styled-components';
import breakpoints from 'utils/breakpoints';
import { Section, Container } from 'components/shared';
import { getFieldValue, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import cx from 'classnames';

const HeadingContainer = styled.div`
  @media ${breakpoints.lg} {
    max-width: 35rem;
  }
`;
const FormsTitleContainer = styled(Container)`
  max-width: 53.75rem;
`;
const CopyContainer = styled.div`
  @media ${breakpoints.lg} {
    max-width: 45rem;
  }
`;
const RequiredCopy = styled(Copy)`
  ${({ signUpForUpdatesStyle }) =>
    signUpForUpdatesStyle ? 'font-size: 0.813rem;' : ''};
  ${({ signUpForUpdatesStyle }) =>
    signUpForUpdatesStyle ? 'color: #777;' : ''};
`;
const Divider = styled.hr`
  border-top: 1px solid #e0e4ea;
  margin: 0 0 20px;
`;

const RegistrationPromo = ({ fields, rendering }) => {
  const headline = getFieldValue(fields, 'headline');
  const description = getFieldValue(fields, 'description');
  const dynamicsFormFields = getFieldValue(fields, 'dynamicsFormFields');
  useEffect(() => {
    setTimeout(() => {
      console.log('trying to load FormCapture script on RegistrationPromo');
      let formCaptureScript = document.createElement('script');
      formCaptureScript.src =
        'https://cxppusa1formui01cdnsa01-endpoint.azureedge.net/can/FormCapture/FormCapture.bundle.js';
      formCaptureScript.onload = () => {
        console.log('RegistrationPromo FormCapture script loaded');
      };
      formCaptureScript.onerror = (e) => {
        console.log('RegistrationPromo FormCapture script error', e);
      };
      document.head.appendChild(formCaptureScript);
    }, 1000);
  }, []);
  const signUpForUpdatesStyle = true;

  return (
    <>
      <Section
        className={cx(' ', {
          'bg-light-blue ': !signUpForUpdatesStyle,
        })}
        id={'contact'}
      >
        <FormsTitleContainer className='w-full'>
          <div
            className={cx('flex flex-col w-full', {
              'items-center text-center md:mb-12 ': !signUpForUpdatesStyle,
              'items-left text-left ': signUpForUpdatesStyle,
            })}
          >
            <HeadingContainer>
              <Heading as='h2' className='lg:my-1'>
                {headline}
              </Heading>
            </HeadingContainer>
            <CopyContainer>
              <Copy className='leading-relaxed'>{description}</Copy>
            </CopyContainer>
          </div>
          {signUpForUpdatesStyle && (
            <CopyContainer>
              <RequiredCopy
                className='leading-relaxed'
                signUpForUpdatesStyle={signUpForUpdatesStyle}
              >
                {'Required fields are marked with *'}
              </RequiredCopy>
            </CopyContainer>
          )}
          {signUpForUpdatesStyle && <Divider className=' ' />}
          <Placeholder
            name='form-wrapper'
            rendering={rendering}
            enableDynaMXFormAPI={true}
            dynamicsFormFields={dynamicsFormFields}
          />
        </FormsTitleContainer>
      </Section>
    </>
  );
};

export default RegistrationPromo;
